import type { SVGProps } from 'react';

const SvgPageFirstHorizontally = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m11.41 12 7.29-7.29a.996.996 0 1 0-1.41-1.41l-8 8a.996.996 0 0 0 0 1.41l8 8c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM7 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgPageFirstHorizontally;
